import { StringObject } from '@intelliarts/ia-react-template';

import employees from '../../components/Employee/locales/employeesLocale-en';

const localizationEN: StringObject = {
  template: {
    src: {
      components: {
        layout: {
          header: {
            appName: 'Employees'
          }
        },
        dialog: {
          cancelButton: 'Cancel'
        },
        error: {
          default: {
            defaultErrorMessage: 'Ops, we\'ve got an error'
          }
        }
      }
    }
  },
  /********************************************/
  src: {
    components: {
      pages: {
        notFoundPage: {
          message: 'Page not found..'
        },
        headcountDashboard: {
          title: 'Headcount Dashboard',
          chooseYear: 'Choose a year',
          numbersOnAGlance: 'Numbers at a glance',
          noData: 'No data for this year.',
          projectsNoData: 'No project data for this year.',
          headcountActiveHint: 'Active: {{count}}',
          headcountInactiveHint: 'Leaves: {{count}}',
          employeesPerStatusMath:
            'Total {{total}} = active {{active}} + leaves {{inactive}}.',
          loadError: 'Could not load headcount data. Please try again.',
          retry: 'Retry',
          yearlyTrendUnavailable: 'Yearly headcount trend is not available from the server for this environment.',
          newComersHint: 'Joined during {{year}}',
          newComersShareOfHeadcount: '{{percent}}% of total headcount',
          benchShareOfActive: '{{percent}}% of active staff',
          benchHint: 'Waiting for an allocation',
          benchNoDataBefore: 'Bench was not tracked before {{year}}',
          vsPreviousYear: '{{delta}} vs {{year}}',
          vsPreviousMonth: '{{delta}} vs {{month}}',
          deltaAbsolute: '{{value}}',
          deltaTenureYears: '{{value}} yrs',
          widgets: {
            headcount: 'Headcount',
            employeesPerStatus: 'By status',
            averageTenure: 'Average tenure',
            newComers: 'Newcomers',
            onBench: 'On bench',
            headcountGrowth: 'Growth',
            headcountByGender: 'By gender',
            headcountByLocation: 'By location',
            headcountByTenure: 'By tenure',
            headcountMom: 'Month over month',
            headcountByProjects: 'By projects',
          },
          stats: {
            projects: 'Projects',
            biggestProject: 'People on biggest project ({{name}})',
            subProjects: 'People on {{group}} sub-projects ({{count}})',
          },
          sort: {
            label: 'Sort projects',
            byName: 'By name',
            byPeople: 'By people',
          },
          groups: {
            label: 'Project groups',
            expand: 'Expand {{group}}',
            collapse: 'Collapse {{group}}',
          },
          generalHc: {
            active: 'Active',
            maternity: 'Maternity',
            military: 'Military',
            sabbatical: 'Sabbatical',
          },
          yoy: {
            avgHc: 'Average headcount',
            selectedYear: 'Selected year',
            growthPercent: 'YoY growth (%)',
          },
          mom: {
            segmentActive: 'Active',
            segmentAllocated: 'Allocated',
            segmentBench: 'Bench',
            segmentInactive: 'Leaves',
            futureMonths: 'Future months',
          },
          projects: {
            other: 'Other projects',
            hubSpot: 'HubSpot',
          },
          breakdown: {
            male: 'Male',
            female: 'Female',
            lviv: 'Lviv',
            ukraineRemote: 'Ukraine Remote',
            abroad: 'Abroad',
            tenureLt2: '<2 years',
            tenure2to5: '2–5 years',
            tenure5to10: '5–10 years',
            tenureGt10: '10+ years',
            headcount: 'Headcount',
          },
          tenureYearsShort: '{{years}} yrs',
        },
        turnoverDashboard: {
          title: 'Turnover Dashboard',
          chooseYear: 'Choose a year',
          numbersOnAGlance: 'Numbers at a glance',
          noData: 'No turnover data for this year.',
          noLeavers: 'Nobody left during the selected year.',
          noVoluntaryExits: 'No voluntary exits in the selected year.',
          noInvoluntaryExits: 'No involuntary exits in the selected year.',
          loadError: 'Could not load turnover data. Please try again.',
          retry: 'Retry',
          monthlyTurnoverHint: 'Current month: {{month}}',
          turnoverRateHint: '{{count}} employees left during the selected year',
          probationFailureHint: '{{count}} probation failures',
          newHireTurnoverHint: '{{count}} new hires left within the first year',
          retentionHint: 'Start: {{start}}, end: {{end}}',
          vsPreviousPeriod: '{{delta}} vs {{period}}',
          deltaPp: '{{value}} pp',
          projectsHint: 'Label: rate% (people who left); colour splits it by exit type. Small teams (≤3) are charted separately.',
          projectsNoDataForYear: 'Project assignments were not recorded in {{year}}, so turnover cannot be broken down by project. Project-level data starts in 2026.',
          projectsChartedSeparately: 'All project leavers in {{year}} sat on small teams — see Small Teams beside this chart.',
          widgets: {
            monthlyTurnoverRate: 'Monthly turnover',
            yearlyTurnoverRate: 'Yearly turnover',
            probationFailureRate: 'Probation Failure Rate',
            newHireTurnoverRate: 'New Hire Turnover Rate',
            retentionRate: 'Retention Rate',
            turnoverVoluntaryVsInvoluntary: 'Voluntary vs Involuntary',
            turnoverVoluntaryReasons: 'Voluntary Reasons',
            turnoverInvoluntaryReasons: 'Involuntary Reasons',
            turnoverByProjects: 'Turnover by Projects',
            turnoverInSmallTeams: 'Small Teams',
            turnoverRateComparison: 'Turnover Rates',
          },
          rates: {
            axisHint: 'Bars: turnover rate (% of average headcount, left). Blue line: people who left (right).',
            viewLabel: 'Period',
            monthly: 'Monthly',
            yearly: 'Yearly',
            rateAxis: 'Turnover Rate',
            exitsAxis: 'People who left',
            total: 'Total',
            voluntary: 'Voluntary',
            involuntary: 'Involuntary',
            exits: 'People who left',
            ytdYear: '{{year}} (YTD)',
            tooltip: '{{rate}} — {{count}} of {{headcount}} people',
            unclassifiedInYear: '{{count}} of {{total}} leavers in {{year}} have no change type — Voluntary + Involuntary fall short of Total.',
            unclassifiedSince: '{{count}} of {{total}} leavers since {{from}} have no change type — Voluntary + Involuntary fall short of Total.',
          },
          breakdown: {
            voluntary: 'Voluntary',
            involuntary: 'Involuntary',
            notSpecified: 'Not Specified',
          },
          projects: {
            employeesWhoLeft: 'People who left',
            turnoverRate: 'Turnover rate',
            tooltip: '{{rate}} — {{left}} of {{headcount}} people',
            groupsLabel: 'Project groups',
            expandGroup: 'Expand {{group}}',
            collapseGroup: 'Collapse {{group}}',
            quietProjects: '{{count}} more projects lost nobody in {{year}}',
            groupBreakdown: 'Showing {{shown}} of {{count}} {{group}} sub-projects ({{headcount}} people). Click a bar to collapse.',
            smallTeamsHint: 'Bars: people who left (not rates), split by exit type. Teams of ≤3 are too small for reliable percentages.',
            smallTeamLabel: '{{left}} of {{size}}',
            smallTeamTooltip: '{{left}} of {{size}} people',
          },
        },
      },
      employees,
    },
    /********************************************/
    config: {
      routesConfigs: {
        notFoundPageConfig: {
          name: 'Not Found Page'
        },
        headcountPageConfig: {
          name: 'Headcount Dashboard',
          label: 'Headcount Dashboard'
        },
        turnoverPageConfig: {
          name: 'Turnover Dashboard',
          label: 'Turnover Dashboard'
        },
      },
    },
    /********************************************/
  }
};

export default localizationEN;
